import { gql } from "@apollo/client";

export const GET_BONUS = gql`
  query GetBonus($id: Int!) {
    bonus(id: $id) {
      id
      name
      description
      type
      value
      valueType
      maxAmount
      minDeposit
      quantity
      period
      startDate
      endDate
      expiryDuration
      isActive
      code
      autoIssue
      isStackable
      conditions
      createdAt
      updatedAt
    }
  }
`;

export const SPIN_HOURLY_BONUS = gql`
mutation SpinHourlyBonus {
  spinHourlyBonus {
    ... on BonusClaimSuccessResult {
      __typename
      success
      amount
      extraSpins
      next
      rewardType
    }
    ... on BonusClaimUsedResult {
      __typename
      used
      next
    }
  }
}
`;

export const BONUS_ELIGIBILITY_QUERY = gql`
  query BonusEligibility {
    bonusEligibility {
      code
      eligible
      next
      reason
    }
  }
`;

export const CLAIM_DAILY_BONUS = gql`
mutation ClaimDailyBonus {
  claimDailyBonus {
    ... on BonusClaimSuccessResult {
      success
      amount
      extraSpins
      next
      rewardType
    }
    ... on BonusClaimUsedResult {
      used
      next
    }
  }
}
`;

export const VALIDATE_PROMO_CODE = gql`
  query ValidatePromoCode($code: String!, $type: PromoCodeTypeEnum!) {
    validatePromoCode(code: $code, type: $type) {
      isValid
      message
      promo {
        id
        code
        name
        amount
        minDeposit
        expiresAt
        isActive
        type
        ownerId
      }
    }
  }
`;